import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var Options3d = function (_Component) {
  _inherits(Options3d, _Component);

  function Options3d() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Options3d);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Options3d.__proto__ || _Object$getPrototypeOf(Options3d)).call.apply(_ref, [this].concat(args))), _this), _this.update3dOptions = function () {
      var _this$props = _this.props,
          alpha = _this$props.alpha,
          axisLabelPosition = _this$props.axisLabelPosition,
          beta = _this$props.beta,
          depth = _this$props.depth,
          fitToPlot = _this$props.fitToPlot,
          frame = _this$props.frame,
          viewDistance = _this$props.viewDistance,
          getChart = _this$props.getChart;


      var opts = {
        chart: {
          options3d: {
            enabled: true,
            alpha: alpha,
            axisLabelPosition: axisLabelPosition,
            beta: beta,
            depth: depth,
            fitToPlot: fitToPlot,
            frame: frame,
            viewDistance: viewDistance
          }
        }
      };
      var chart = getChart();
      chart.update(opts, true);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Options3d, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.update3dOptions();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.update3dOptions();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Options3d;
}(Component);

Options3d.defaultProps = {
  enabled: false,
  alpha: 0,
  beta: 0,
  depth: 100,
  fitToPlot: true,
  viewDistance: 25,
  axisLabelPosition: 'default',
  frame: {
    visible: 'default',
    size: 1,
    bottom: {},
    top: {},
    left: {},
    right: {},
    back: {},
    front: {}
  }
};


export default Options3d;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jsx-highcharts/dist/es/components/Options3d/Options3d.js
// module id = 809
// module chunks = 0